<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-06-01 08:57:21
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-09-26 15:18:52
-->
<template>
  <!--  <config-item v-show="isShow" :label='label'>-->

  <div>
    <div style="display: flex; align-items: center" class="mb20">
      <div class="w120 f13 f-grey pl12 mr10 lh-28">
        {{ label }}
      </div>
      <div style="flex: 1">
        <el-select
          style="width: 100%"
          v-model="mValue.tagSource"
          size="small"
          @change="change"
        >
          <el-option
            v-for="(item, index) in tagList"
            :key="index"
            :label="item.name"
            :value="item.url"
          />
        </el-select>
      </div>
    </div>
    <!--控制展示内容-->
    <div v-if="mValue.isConDisContent" style="display: flex">
      <div class="w120 f13 f-grey pl12 mr10 lh-28">{{ mValue.title }}</div>

      <div style="flex: 1">
        <el-checkbox-group v-model="mValue.displayContent">
          <el-checkbox
            :label="item.target"
            :value="item.target"
            v-for="(item, index) in dataList"
            v-if="item.target != 'keyword'"
            :key="item.target || index"
          >
            {{ item.targetName ? item.targetName : item.sourceName }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </div>

  <!--  </config-item>-->
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import {
  comDSList,
  getDatasourceList,
  getRuleList,
} from "../../../api/easyApp";
import { mapGetters, mapMutations } from "vuex";
import { deepClone } from "../../../js/utils";

export default {
  name: "SchemaTagSourceSampler",
  mixins: [schemaMixin],
  props: {
    labelSwitch: {
      default: true,
    },
    isShow: {
      default: true,
    },
    tagCategory: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: {},
    },
  },

  inject: ["mode"],

  data() {
    return {
      defaultOptions: {
        trueLabel: "显示",
        falseLabel: "隐藏",
      },
      tagList: [],
      valueNew: "",
      dataList: [],
      decRule: [],
      searchRuleSign: "",
    };
  },
  computed: {
    ...mapGetters(["project"]),
  },

  async created() {
    let res1 = await getRuleList([this.tagCategory]);

    this.decRule = JSON.parse(res1.data[0].ruleData);

    this.mValue.decRule = JSON.parse(res1.data[0].ruleData);

    let data = {
      tags: this.tagCategory,
      //sceneType: this.project.sceneType + ",GGXX",
    };

    let res = await getDatasourceList(data);
    this.tagList = res.data;

    if (this.mValue.tagSource) {
      console.log("重新获取一遍数据");

      let index = this.tagList.findIndex(
        (item) => item.url == this.mValue.tagSource,
      );

      console.log("index:", index);

      if (index != -1) {
        let configContent = JSON.parse(
          this.tagList[index].dataMapperList[0].configContent,
        );


        if (!Array.isArray(configContent)) {
          let paramsData = [];

          if (configContent.paramsData) {
            for (let i in configContent.paramsData) {
              paramsData.push({ target: i, ...configContent.paramsData[i] });
            }
            this.mValue.paramsData = deepClone(paramsData);
            this.mValue.paramsDataSelect = {};
            this.loadParamsData = false;
            this.mValue.paramsData.forEach(async (item, index) => {
              if (item.type && item.type == "helper") {
                if (item.params.type == "remoto") {
                  let res = await getDatasourceByDsId(item.params.value);
                  getDatasourceByUrl(res.data.url).then((result) => {
                    if (result.code == 0) {
                      item.params.list = result.data.map((ele) => ({
                        name: ele.name,
                        value: ele[item.target],
                      }));
                    }
                  });
                }
                this.mValue.paramsDataSelect[item.source] = "";
              }
              if (index == this.mValue.paramsData.length - 1) {
                setTimeout(() => { this.loadParamsData = true; }, 1000);
              }
            });
          } else {
            this.mValue.paramsData = [];
          }
        }


        let configContentNew = [];
        for (const i in configContent) {
          if (configContent[i].type) {
            if (configContent[i].type == "sampler") {
              this.mValue.samplerRule = configContent[i].ruleId;
            } else if (configContent[i].type == "rule") {
              this.mValue.secMapper = configContent[i].ruleMapper;
            }

            for (const j in configContent[i].ruleMapper) {
              let obj = configContent[i].ruleMapper[j];
              obj["target"] = j;
              obj["targetName"] = configContent[i].ruleMapper[j].sourceName;
              configContentNew.push(obj);
            }
          } else {
            let obj = configContent[i];
            obj["target"] = i;
            obj["targetName"] = configContent[i].sourceName;
            configContentNew.push(obj);
          }
        }

        this.mValue.dataMapper = deepClone(configContentNew);

        this.dataList = configContentNew.filter(
          (item) => item.target != "keyword",
        );

        if (this.mValue.isSupportSearch == true) {
          let index = this.mValue.dataMapper.findIndex(
            (item) => item.target == "keyword",
          );

          if (index != -1) {
            this.mValue.realSearchSign = this.mValue.dataMapper[index].source;
          }
        }
      }
    } else {
      this.mValue.tagSource = this.tagList[0].url;

      let configContent = JSON.parse(
        this.tagList[0].dataMapperList[0].configContent,
      );

      let configContentNew = [];

      for (const i in configContent) {
        console.log("configContent:", i, configContent[i]);
        //samplerRule
        if (configContent[i].type) {
          if (configContent[i].type == "sampler") {
            this.mValue.samplerRule = configContent[i].ruleId;
          } else if (configContent[i].type == "rule") {
            this.mValue.secMapper = configContent[i].ruleMapper;
            console.log("this.mValue.secMapper:", this.mValue.secMapper);
          }

          for (const j in configContent[i].ruleMapper) {
            let obj = configContent[i].ruleMapper[j];
            obj["target"] = j;
            obj["targetName"] = configContent[i].ruleMapper[j].sourceName;
            configContentNew.push(obj);
          }
        } else {
          let obj = configContent[i];
          obj["target"] = i;
          obj["targetName"] = configContent[i].sourceName;
          configContentNew.push(obj);
        }
      }

      this.mValue.dataMapper = deepClone(configContentNew);
      this.mValue.relationParams = this.tagList[0].relationParams;
      this.dataList = configContentNew.filter(
        (item) => item.target != "keyword",
      );

      if (this.mValue.isSupportSearch == true) {
        //this.mValue.dataMapper
        let index = this.mValue.dataMapper.findIndex(
          (item) => item.target == "keyword",
        );

        if (index != -1) {
          this.mValue.realSearchSign = this.mValue.dataMapper[index].source;
        }
      }

      let displayContent = [];

      for (const i in this.mValue.dataMapper) {
        displayContent.push(this.mValue.dataMapper[i].target);
      }

      this.mValue.displayContent = displayContent;
    }
  },
  methods: {
    change(val) {
      let index = this.tagList.findIndex((item) => item.url == val);

      if (index != -1) {
        let configContent = JSON.parse(
          this.tagList[index].dataMapperList[0].configContent,
        );
        console.log("configContent:",configContent);

        if (!Array.isArray(configContent)) {
          let paramsData = [];



          if (configContent.paramsData) {
            for (let i in configContent.paramsData) {
              paramsData.push({ target: i, ...configContent.paramsData[i] });
            }
            this.mValue.paramsData = deepClone(paramsData);
            this.mValue.paramsDataSelect = {};
            this.loadParamsData = false;
            this.mValue.paramsData.forEach(async (item, index) => {
              if (item.type && item.type == "helper") {
                if (item.params.type == "remoto") {
                  let res = await getDatasourceByDsId(item.params.value);
                  getDatasourceByUrl(res.data.url).then((result) => {
                    if (result.code == 0) {
                      item.params.list = result.data.map((ele) => ({
                        name: ele.name,
                        value: ele[item.target],
                      }));
                    }
                  });
                }
                this.mValue.paramsDataSelect[item.source] = "";
              }
              if (index == this.mValue.paramsData.length - 1) {
                setTimeout(() => { this.loadParamsData = true; }, 1000);
              }
            });
          } else {
            this.mValue.paramsData = [];
          }
        }



        let configContentNew = [];
        for (const i in configContent) {
          console.log("configContent:", i, configContent[i]);
          //samplerRule
          if (configContent[i].type) {
            if (configContent[i].type == "sampler") {
              this.mValue.samplerRule = configContent[i].ruleId;
            } else if (configContent[i].type == "rule") {
              this.mValue.secMapper = configContent[i].ruleMapper;
            }

            for (const j in configContent[i].ruleMapper) {
              let obj = configContent[i].ruleMapper[j];
              obj["target"] = j;
              obj["targetName"] = configContent[i].ruleMapper[j].sourceName;
              configContentNew.push(obj);
            }
          } else {
            let obj = configContent[i];
            obj["target"] = i;
            obj["targetName"] = configContent[i].sourceName;
            configContentNew.push(obj);
          }
        }
        this.mValue.dataMapper = deepClone(configContentNew);
        this.mValue.relationParams = this.tagList[0].relationParams;
        this.dataList = configContentNew.filter(
          (item) => item.target != "keyword",
        );

        if (this.mValue.isSupportSearch == true) {
          //this.mValue.dataMapper
          let index1 = this.mValue.dataMapper.findIndex(
            (item) => item.target == "keyword",
          );
          console.log("index1index1index1:", index1);
          if (index1 != -1) {
            this.mValue.realSearchSign = this.mValue.dataMapper[index1].source;
          }
        }

        this.$forceUpdate();
        let displayContent = [];
        for (const i in this.mValue.dataMapper) {
          displayContent.push(this.mValue.dataMapper[i].target);
        }
        this.mValue.displayContent = displayContent;
        this.mValue.relationParams = this.tagList[index].relationParams;
      } else {
        this.mValue.displayContent = [];
        this.mValue.relationParams = "";
        this.mValue.realSearchSign = "";
        this.mValue.samplerRule = "";
        this.mValue.secMapper = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 25px;
  /*no*/

  .wrap-label {
    font-size: 14px;
    /*no*/
    line-height: 32px;
    /*no*/
  }
}
</style>
